var _g, _g2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX2PointerMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 46.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Polygon 1",
    fill: "#ffb54e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.202 46.3H6.798a3.468 3.468 0 01-3.016-1.725 3.468 3.468 0 01-.043-3.475L22.94 6.537a3.457 3.457 0 013.06-1.8c1.29 0 2.433.672 3.06 1.8L48.26 41.1a3.468 3.468 0 01-.043 3.475 3.468 3.468 0 01-3.016 1.725z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 5.236a2.963 2.963 0 00-2.622 1.544L4.176 41.343a2.973 2.973 0 00.036 2.978A2.973 2.973 0 006.798 45.8h38.404c1.074 0 2.04-.553 2.586-1.479.544-.925.558-2.039.036-2.978L28.622 6.78A2.963 2.963 0 0026 5.236m0-1a3.96 3.96 0 013.497 2.058l19.202 34.563c1.48 2.667-.447 5.943-3.497 5.943H6.798c-3.05 0-4.978-3.276-3.497-5.943L22.503 6.294A3.96 3.96 0 0126 4.236z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 102",
    transform: "translate(13 19)",
    fill: "#fff",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(26 40)",
    fill: "#ffb54e",
    fontSize: 22,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.118,
    y: 0
  }, "2"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX2PointerMark);
export default __webpack_public_path__ + "static/media/X2PointerMark.aa6eac437c061220.svg";
export { ForwardRef as ReactComponent };